module.exports = __webpack_public_path__ + "static/graph-2_fr-67e6d20b029529a227c4265738033148.svg";